<template>
  <f7-page data-tour-id="issued-invoices-details-page-root">
    <!-- LOADER BONITO NO BLOQUEANTE -->
    <div v-if="loading" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">{{ $t('loading') }}</div>
      </div>
    </div>

    <div>
      <div v-if="loaded" class="tableContainer">
        <div class="summary-header">
          <div class="summary-title">
            <div class="summary-icon-invoices"></div>
            <div class="summary-text">
              {{ $t('issuedInvoiceDetails') }}
            </div>
          </div>
          <div class="summary-actions">
            <button
              class="download-button"
              @click="$refs.issuedInvoicesDetails.downloadInvoice()"
            >
              <span class="download-button__label">
                {{ $t('download') }}
              </span>
            </button>
          </div>
        </div>
        <IssuedInvoicesDetails ref="issuedInvoicesDetails" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import IssuedInvoicesDetails from '@/components/IssuedInvoicesList/IssuedInvoicesDetails/index.vue';
import { mapActions, mapState } from 'vuex';
import { ISSUED_INVOICES_GUIDED_TOUR_AUTO_START_DELAY } from '@/js/constants';
import {
  consumePendingIssuedInvoicesDetailsTourStart,
  startIssuedInvoicesDetailsGuidedTour,
  stopIssuedInvoicesGuidedTour,
} from '@/services/issuedInvoicesGuidedTour';

export default {
  components: {
    IssuedInvoicesDetails,
  },
  data() {
    return {
      customStore: null,
      loading: false,
      loaded: false,
      guidedTourStartTimeoutId: null,
    };
  },
  computed: {
    urlName() {
      return this.lastRouteHome ? 'Home' : 'issuedInvoicesList';
    },
    ...mapState('samples', ['lastRouteHome']),
    ...mapState('issuedInvoicesModule', ['isLoading']),
  },
  watch: {
    isLoading: {
      immediate: true,
      handler(v) {
        this.loading = v;
        if (!v) {
          this.loaded = true;
          this.scheduleIssuedInvoicesGuidedTourStart();
        }
      },
    },
    loaded(value) {
      if (value) {
        this.scheduleIssuedInvoicesGuidedTourStart();
      } else {
        this.clearIssuedInvoicesGuidedTourStartTimeout();
      }
    },
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('issuedInvoiceDetails'),
        disabled: false,
        page: 'issuedInvoicesDetails',
        active: true,
      },
    ]);
    this.setCurrentFilter('issuedInvoicesDetails');
  },
  beforeDestroy() {
    this.clearIssuedInvoicesGuidedTourStartTimeout();
    stopIssuedInvoicesGuidedTour(this);
  },
  methods: {
    clearIssuedInvoicesGuidedTourStartTimeout() {
      if (this.guidedTourStartTimeoutId) {
        clearTimeout(this.guidedTourStartTimeoutId);
        this.guidedTourStartTimeoutId = null;
      }
    },
    scheduleIssuedInvoicesGuidedTourStart({ force = false } = {}) {
      if (!this.loaded || this.loading) return;

      const shouldContinueFromList =
        force || consumePendingIssuedInvoicesDetailsTourStart();
      if (!shouldContinueFromList) {
        return;
      }

      this.clearIssuedInvoicesGuidedTourStartTimeout();
      this.guidedTourStartTimeoutId = setTimeout(() => {
        this.guidedTourStartTimeoutId = null;
        startIssuedInvoicesDetailsGuidedTour(this, {
          force: true,
        });
      }, ISSUED_INVOICES_GUIDED_TOUR_AUTO_START_DELAY);
    },
    hasTourSampleAction() {
      return (
        this.$refs.issuedInvoicesDetails?.hasTourSampleAction?.() ===
        true
      );
    },
    async prepareTourSampleAction() {
      return (
        (await this.$refs.issuedInvoicesDetails?.prepareTourSampleAction?.()) ||
        false
      );
    },
    setSelectedIndex(e) {
      if (e.name === 'selectedIndex') {
        this.selectedRoute = e.value;
      }
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
  },
};
</script>

<style scoped>
.summary-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  background: var(--Primary-Blue-70, #00346a);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-right: 8px;
}

.download-button::before {
  content: '';
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url('@/static/icons/download.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.download-button:hover {
  background: #002d5a;
}

.download-button__label {
  padding-left: 18px;
}
</style>
